import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Modal from 'components/new_ui/Modal/Modal';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import Stripe from 'components/Members/Wallet/Popup/Stripe';
import Items from './BuyPopup/Items';

import Actions from './Actions';

export default function BuyModal({
  invoice, closeModal, setWaitPayment,
}) {
  const [clientSecret, setClientSecret] = useState(null);

  useEffect(() => {
    Actions.preparePayment((data) => {
      setClientSecret(data.client_secret);
    }, () => {
      // TODO: error case
    });
  }, [invoice]);

  return (
    <Modal onHide={closeModal} header={<h3>Summary</h3>} show>
      <div className="wallet-summary">
        {clientSecret === null && <LoadingPlaceholder text="Loading..." />}
        {clientSecret !== null && (
          <>
            <Items invoice={invoice} />
            <Stripe
              clientSecret={clientSecret}
              closeModal={closeModal}
              setWaitPayment={setWaitPayment}
              currency={invoice.attributes.currency}
            />
          </>
        )}
      </div>

    </Modal>
  );
}

BuyModal.propTypes = {
  invoice: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
  setWaitPayment: PropTypes.func.isRequired,
};
